import {Spin} from '@osui/ui';
import c from './index.less';

export default function SpinAlignCenter() {
    return (
        <div className={c['spinAlignCenter']}>
            <Spin />
        </div>
    );
}
